export const BUCKETING_API_URL = 'https://cdn.flagship.io/{0}/bucketing.json';
export const FS_FORCED_VARIATIONS = 'FS_FORCED_VARIATIONS';
export const FS_VARIATIONS_FORCED_ALLOCATION = 'FS_VARIATIONS_FORCED_ALLOCATION';
export const FS_VARIATIONS_FORCED_UNALLOCATION = 'FS_VARIATIONS_FORCED_UNALLOCATION';
export const FS_HITS = 'FS_HITS';

export const FS_FEATURE_FLAGS_SDK_VERSION = {
  ENABLE_FORCE_ALLOCATION: [
    {
      sdkName: 'TypeScript',
      minVersion: '5.1.8',
      tag: 'flagship-ts-sdk',
    },
    {
      sdkName: 'ReactJS',
      minVersion: '5.2.1',
      tag: 'flagship-react-sdk',
    },
  ],
};
